import { WalletToDisplayInfo } from 'src/hooks/useWalletsToDisplay';
import { DriftWalletName } from 'src/constants/wallets';
import { WalletButton } from 'src/components/ConnectWalletButtonsList/WalletButton';
import { EmailWalletsList } from 'src/components/ConnectWalletButtonsList/EmailWalletsList';

export const MoreWalletsPage = (props: {
	detectedWallets: WalletToDisplayInfo[];
	nonDetectedWallets: WalletToDisplayInfo[];
	onChooseWallet: (walletName: DriftWalletName) => void;
	onBack: () => void;
}) => {
	return (
		<div className="flex flex-col gap-y-md">
			{props.detectedWallets.map((walletProvider, index) => (
				<WalletButton
					onChooseWallet={() => {
						if (walletProvider.action) {
							walletProvider.action();
							return;
						}

						props.onChooseWallet?.(walletProvider.provider.adapter.name);
					}}
					wallet={walletProvider}
					key={walletProvider.provider.adapter.name + index}
				/>
			))}
			<EmailWalletsList onChooseWallet={props.onChooseWallet} />

			{props.nonDetectedWallets.map((walletProvider, index) => (
				<WalletButton
					onChooseWallet={() => {
						if (walletProvider.action) {
							walletProvider.action();
							return;
						}

						props.onChooseWallet?.(walletProvider.provider.adapter.name);
					}}
					wallet={walletProvider}
					key={walletProvider.provider.adapter.name + index}
				/>
			))}
		</div>
	);
};
